import React from "react";
import ModalNotification from "../ModalNotification";
import styled from "styled-components";
import Button from "../Button";

const NotificationSuccess = ({ isOpen = false, account, onClose = () => {} }) => {
  return (
    <ModalNotification
      isOpen={isOpen}
      title="Transacción exitosa"
      description={
        <WrapperMessage>
          <Message>El curso está activado</Message>
          <Credentials>
            <WrapperField>
              <FieldLabel>Correo</FieldLabel>
              <FieldValue>{account?.email}</FieldValue>
            </WrapperField>
            {account?.password !== undefined && (
              <WrapperField>
                <FieldLabel>Contraseña</FieldLabel>
                <FieldValue>{account?.password}</FieldValue>
              </WrapperField>
            )}
          </Credentials>
        </WrapperMessage>
      }
      buttons={
        <>
          <ButtonStyled primary={true} text="Aceptar" onClick={onClose} />
        </>
      }
      type="success"
    />
  );
};


const WrapperField = styled.div`
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    margin-bottom: 30px;
  }
`;

const FieldLabel = styled.div`
  margin-bottom: 10px;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: bold;
`;

const FieldValue = styled.div``;

const Credentials = styled.div``;

const Message = styled.div`
  margin-bottom: 30px;
`;

const WrapperMessage = styled.div``;

const ButtonStyled = styled(Button)`
  .button {
    background-color: #33c494;
  }
`;

export default NotificationSuccess;
